import Modal from "../../shared/components/UI/Modal/Modal";
import './UserAgreementModal.scss'
import { Dispatch, SetStateAction } from "react";

export default function UserAgreementModal({
  isOpen,
  setIsOpen
}: {
  isOpen: boolean,
  setIsOpen: Dispatch<SetStateAction<boolean>>
}) {
  return (
    <Modal isOpen={isOpen} closeModal={() => setIsOpen(false)} className="userAgreementModal">
      <div className="userAgreementModal-title">
        <h2>Пользовательское соглашение</h2>
      </div>

      <div className="userAgreementModal-content">
        <div className="ua-meta">
          <div className="ua-version">Версия: 1.0 · Дата обновления: 05.10.2025 · Правообладатель: ООО «Киберштаб»</div>
        </div>

        <h3 className="ua-section-title">Содержание</h3>
        <p className="ua-body">
          1. Общие положения · 2. Термины и определения · 3. Регистрация и аккаунт · 4. Права и обязанности сторон · 5. Услуги, платежи и возвраты · 6. Контент и права интеллектуальной собственности · 7. Конфиденциальность и данные · 8. Ограничение ответственности · 9. Применимое право и разрешение споров · 10. Заключительные положения и контакты
        </p>

        <h3 className="ua-section-heading">1. Общие положения</h3>

        <p className="ua-body">
          1.1. Настоящее Пользовательское соглашение (далее — «Соглашение") регулирует отношения между ООО «Компания» и пользователем веб‑сайта и/или мобильного приложения (далее — «Сервис»).
        </p>

        <p className="ua-body">
          1.2. Используя Сервис, вы подтверждаете, что прочитали и принимаете условия Соглашения. Если вы не согласны с условиями, прекратите использование Сервиса.
        </p>

        <p className="ua-body">
          1.3. Компания вправе обновлять Соглашение. Новая редакция вступает в силу с момента публикации в Сервисе.
        </p>

      </div>
    </Modal>
  )
}
